/* eslint-disable no-restricted-imports */
import { isValid } from 'date-fns';

import { parseDate } from './parseDate';
import { getDateFeatureConfig } from './DateConfigType';
import type { DateFormat } from './dateFormats';

/**
 * Checks if the date is valid.
 *
 * @param date date to check
 * @param formatConfigOverride format to parse the date (defaultDateFormat from the config by default).
 */
export function isValidDate(
    date: string | undefined | null | unknown,
    formatConfigOverride: DateFormat = getDateFeatureConfig(
        (f) => f?.base?.defaultDateFormat,
    ) as DateFormat,
): boolean {
    if (!date) {
        return false;
    }

    if (typeof date === 'string') {
        return isValid(parseDate(date, formatConfigOverride));
    }

    return date instanceof Date && !!date.getTime() && !Number.isNaN(date.getTime());
}
